import classNames from "classnames";
import React from "react";
import { L10n } from "@fidget/common/i18n";
import styles from "./deleteConfirmButtons.css";

interface Props {
  onClick: () => void;
}

export const CancelRemovingButton = ({ onClick }: Props) => (
  <div className={classNames(styles.button, styles.cancel)} onClick={onClick}>
    <L10n id={"cancel"} />
  </div>
);
